import { Injectable } from '@angular/core';
import { ConfigProvider } from "../../config-provider.service";
import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { ApiBaseService } from "../../common/providers/api-base-service";
import { map, Observable } from "rxjs";
import { AgendaComment } from "../../common/models/agenda-comment";
import { CurrentUser } from "../../common/providers/current-user";
import { Paginator } from "../../common/models/paginator";

@Injectable({providedIn: 'root'})
export class AgendaCommentsProvider {
    constructor(
        private _conf: ConfigProvider,
        private _utils: UtilsProvider,
        private _api: ApiBaseService,
        private currentUser: CurrentUser,
    ) {
    }


    public getCommentOf(organizationId: number, agendaId: number, weekfirstday: string): Observable<AgendaComment> {
        return this._api.call('get', `organizations/${organizationId}/agendas/${agendaId}/comments/`, {
          weekfirstday: weekfirstday
        }, this.currentUser.getAccessToken()).pipe(
            map((result: Paginator) => {
                return AgendaComment.fromAPIList(result.data)[0];
            })
        )
    }
        // return this._storage.select(AgendaComment)
        //     .where('weekfirstday').equals(weekfirstday)
        //     .and('agendaId').equals(agendaId)
        //     .get(1);
    // }

}

export interface AgendaCommentRow {
    agendaId: number;
    weekfirstday: string;
    comment: string;
}
